import { render, staticRenderFns } from "./calendar.vue?vue&type=template&id=5fda4359&scoped=true&"
import script from "./calendar.vue?vue&type=script&lang=jsx&"
export * from "./calendar.vue?vue&type=script&lang=jsx&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fda4359",
  null
  
)

export default component.exports